'use strict';

var jsxRuntime = require('react/jsx-runtime');

const MediumPublic = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("path", {
                    d: "M5.99548 8.8207C6.14496 10.5224 6.67387 12.4426 7.92717 14.4778C7.92717 14.4778 7.97317 14.5583 8.04215 14.6618C8.13414 14.5238 8.18013 14.4318 8.18013 14.4318C9.41043 12.4081 9.95085 10.5109 10.1003 8.8092H5.99548V8.8207Z",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("path", {
                    d: "M9.67501 0.679975C9.67501 0.679975 11.5262 3.32455 11.7217 7.18793H15.7C15.5391 5.40572 14.7917 3.77298 13.5269 2.51968C12.4231 1.41586 11.0318 0.71447 9.51404 0.450012C9.60602 0.576492 9.67501 0.668477 9.68651 0.679975H9.67501Z",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("path", {
                    d: "M8.36405 1.6228C8.36405 1.6228 8.23757 1.45032 8.0651 1.20886C7.86963 1.48482 7.73165 1.66879 7.73165 1.66879C7.62817 1.80677 6.14491 3.96842 5.96094 7.1994H10.1348C9.9623 3.92243 8.46753 1.76077 8.36405 1.6113V1.6228Z",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("path", {
                    d: "M6.5476 15.3056C5.13333 12.983 4.54692 10.7869 4.40895 8.82068H0.350098C0.499574 10.6144 1.25845 12.2586 2.52325 13.5234C3.68456 14.6847 5.15633 15.3976 6.75457 15.6391C6.63959 15.4551 6.5591 15.3286 6.5476 15.3171V15.3056Z",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("path", {
                    d: "M11.6873 8.79763C11.5493 10.7523 10.9629 12.9485 9.54862 15.2596C9.54862 15.2711 9.46813 15.3976 9.35315 15.5815C12.6646 14.9376 15.2632 12.1781 15.6656 8.78613H11.6873V8.79763Z",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("path", {
                    d: "M4.38588 7.21098C4.58135 3.3591 6.39805 0.772012 6.43255 0.737517C6.43255 0.726019 6.51304 0.634034 6.61652 0.484558C3.35104 1.15145 0.798455 3.87651 0.384521 7.22247H4.38588V7.21098Z",
                    fill: "currentColor"
                })
            ]
        }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("path", {
                    d: "M8.08 1.00038C4.21021 1.04038 1.04038 4.21021 1.00038 8.08C0.960386 11.9498 4.05022 15.0396 7.92 14.9996C11.7898 14.9596 14.9496 11.7898 14.9996 7.92C15.0396 4.05022 11.9498 0.960386 8.08 1.00038Z",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M1.00057 8.07991L14.9998 7.91992",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M7.03995 1.08032C7.03995 1.08032 2.5302 7.32998 7.19994 14.9696",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M9.11002 1.06042C9.11002 1.06042 13.4798 7.21009 8.63004 14.9597",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                })
            ]
        })
    });
};

module.exports = MediumPublic;
